export default "__VITE_ASSET__Co2cq3SR__"